export default __webpack_public_path__ + "static/media/bg_1.9acf3fbf.jpg";